import { apiRequest } from './api';

// ── Types ────────────────────────────────────────────

export type OverdueInvoiceStatus = 'draft' | 'published' | 'partial' | 'paid' | 'overdue' | 'void';

export type OverdueInvoice = {
    id: string;
    invoice_number: string;
    title: string;
    total_amount: string;
    paid_amount: string;
    balance_amount: string;
    status: OverdueInvoiceStatus;
    due_date: string;
};

export type FeeDefaulterRecord = {
    id: string;
    enrollment_number: string | null;
    roll_number: string | null;
    student: {
        first_name: string;
        last_name: string | null;
        phone: string | null;
    };
    address: string | null;
    father_name: string | null;
    mother_name: string | null;
    father_contact: string | null;
    class: { id: string; name: string };
    section: { id: string; name: string } | null;
    total_overdue_amount: number;
    overdue_invoices: OverdueInvoice[];
};

export type FeeDefaulterListMeta = {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
};

export type FeeDefaulterListResponse = {
    data: FeeDefaulterRecord[];
    meta: FeeDefaulterListMeta;
};

// ── API Functions ─────────────────────────────────────

/** `class_id` is mandatory — the backend rejects the request without it. */
export async function fetchFeeDefaulters(params: {
    class_id: string;
    section_id?: string;
    per_page?: number;
    page?: number;
}): Promise<FeeDefaulterListResponse> {
    const query = new URLSearchParams();
    query.set('class_id', params.class_id);
    if (params.section_id) query.set('section_id', params.section_id);
    query.set('per_page', String(params.per_page ?? 50));
    if (params.page) query.set('page', String(params.page));

    const res = await apiRequest<FeeDefaulterRecord[]>(`/api/reports/fee-defaulters?${query.toString()}`);
    return {
        data: res.data,
        meta: (res as unknown as { meta: FeeDefaulterListMeta }).meta,
    };
}
